import { render, staticRenderFns } from "./bulletinDetail.vue?vue&type=template&id=15674a8e&scoped=true&"
import script from "./bulletinDetail.vue?vue&type=script&lang=js&"
export * from "./bulletinDetail.vue?vue&type=script&lang=js&"
import style0 from "./bulletinDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "../../../company/statistics/css/commonCompany.css?vue&type=style&index=1&id=15674a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15674a8e",
  null
  
)

export default component.exports